import React from 'react';

// Dialog Context
export const DialogContext = React.createContext();
